//引入i18n国际化插件
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

//注册i18n实例并引入语言文件
const locale =
  localStorage.getItem(`${window.current_theme}_locale`) ||
  window.default_language ||
  'English'

export const i18n = new VueI18n({
  locale: 'English', // 用户若直接从弃单进入无法读取到local则使用当前主题默认语言
  messages: {
    English: require('./lang/en-US.json')
  }
})
const loadedLanguages = ['English'] // 我们的预装默认语言

function setI18nLanguage(lang) {
  i18n.locale = lang
  return lang
}

loadLanguageAsync(locale)

export function loadLanguageAsync(lang) {

  // 如果语言相同
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang))
  }
  // 如果语言已经加载
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  let locale = 'en-US'
  // 如果尚未加载语言
  switch (lang) {
    case 'Chinese':
      locale = 'zh-CN'
      break
    case 'Spanish':
      locale = 'sp-ES'
      break
    case 'German':
      locale = 'de-DE'
      break
    case 'French':
      locale = 'fr-FR'
      break
    case 'Portuguese':
      locale = 'pt-PT'
      break
    case 'Italian':
      locale = 'it-IT'
      break
    case 'Japanese':
      locale = 'ja-JP'
      break
    case 'Russian':
      locale = 'ru-RU'
      break
    case 'Dutch':
      locale = 'nl-NL'
      break
    case 'Korean':
      locale = 'ko-KR'
      break
    default:
      break
  }
  return import(/* webpackChunkName: "lang-[request]" */ `@/locales/lang/${locale}.json`).then(messages => {
    i18n.setLocaleMessage(lang, messages.default)
    loadedLanguages.push(lang)
    return setI18nLanguage(lang)
  })
}
